import { cn } from './ui';

/**
 * The klink mark.
 *
 * Rendered as inline SVG rather than an <img> so it stays crisp at every size, needs no network
 * request, and can invert for dark mode. The source asset is a 1024px PNG; at 24px in a header
 * that would be a 230 kB download to draw a letter.
 */
export function Logo({ size = 28, className }: { size?: number; className?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 1024 1024"
      role="img"
      aria-label="klink"
      className={cn('shrink-0', className)}
    >
      <rect width="1024" height="1024" rx="232" className="fill-[--color-brand]" />
      <path
        d="M262 226a16 16 0 0 1 16-16h110a16 16 0 0 1 16 16v154a16 16 0 0 1-16 16H278a16 16 0 0 1-16-16V226Z"
        fill="#fff"
      />
      <path
        d="M262 512 585 213a16 16 0 0 1 11-4h154c14 0 21 17 11 27L438 512l323 276c10 9 3 27-11 27H596a16 16 0 0 1-11-4L262 512Z"
        fill="#fff"
      />
      <path
        d="M262 466a16 16 0 0 1 16-16h110a16 16 0 0 1 16 16v332a16 16 0 0 1-16 16H278a16 16 0 0 1-16-16V466Z"
        fill="#fff"
      />
    </svg>
  );
}

/** Mark plus wordmark, for headers and the sign-in card. */
export function LogoLockup({ size = 28 }: { size?: number }) {
  return (
    <span className="flex items-center gap-2.5">
      <Logo size={size} />
      <span className="text-[0.95rem] font-semibold tracking-tight">
        klink<span className="text-muted-foreground">pbx</span>
      </span>
    </span>
  );
}
